"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConflictError = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const apigw_models_1 = require("@integration/apigw-models");
const HttpError_1 = require("./HttpError");
class ConflictError extends HttpError_1.HttpError {
    constructor(code = 'conflict', metaData) {
        super(409, code, 'Error invoking the backend system', undefined, metaData);
    }
}
tslib_1.__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({ defaultValue: 409, description: 'HTTP Code' }),
    tslib_1.__metadata("design:type", Number)
], ConflictError.prototype, "statusCode", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({ example: 'conflict', description: 'HTTP Status' }),
    tslib_1.__metadata("design:type", String)
], ConflictError.prototype, "code", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({
        example: 'The request could not be completed due to a conflict with the current state of the resource.',
        description: 'Message describing which input(s) fail the validation',
    }),
    tslib_1.__metadata("design:type", String)
], ConflictError.prototype, "message", void 0);
exports.ConflictError = ConflictError;
